import { Link } from "react-router-dom";
import "./Button.css";
import { useEffect, useState } from "react";

const Button = ({
  children,
  onClick,
  disabled,
  size,
  span,
  type,
  linkObj,
  plane,
  className
}: {
  children: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  size?: `sm` | `md` | `lg`;
  linkObj?: {
    href: string;
    external?: boolean;
    target?: React.HTMLAttributeAnchorTarget;
  };
  type?: `submit` | `button`;
  span?: boolean;
  plane?: boolean;
  className?: string;
}) => {
  const classNameString = `btn_link ${span ? `flex1` : ``}`;

  return linkObj ? (
    linkObj.external ? (
      <a
        className={classNameString}
        href={linkObj.href}
        target={linkObj.target}
      >
        <BtnComp
          children={children}
          onClick={onClick}
          disabled={disabled}
          size={size}
          type={type}
          span={span}
          plane={plane}
          className={className}
        />
      </a>
    ) : (
      <Link
        target={linkObj.target}
        to={linkObj.href || `#`}
        className={classNameString}
      >
        <BtnComp
          children={children}
          onClick={onClick}
          disabled={disabled}
          size={size}
          type={type}
          span={span}
          plane={plane}
          className={className}
        />
      </Link>
    )
  ) : (
    <BtnComp
      children={children}
      onClick={onClick}
      disabled={disabled}
      size={size}
      type={type}
      span={span}
      plane={plane}
      className={className}
    />
  );
};

const BtnComp = ({
  children,
  onClick,
  disabled,
  size,
  span,
  type,
  plane,
  className
}: {
  children: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
  size?: `sm` | `md` | `lg`;
  type?: `submit` | `button`;
  span?: boolean;
  plane?: boolean;
  className?: string;
}) => {
  return (
    <button
      type={type || "button"}
      disabled={!!disabled}
      onClick={(e) => {
        if (onClick) {
          onClick(e);
        }
      }}
      className={`reg_text ${plane ? `btnPlane` : `btn`} ${size || ``} ${
        span ? `flex1` : ``
      } ${className || ""}`}
    >
      {children}
    </button>
  );
};

export default Button;
